export class PasswordChangeModel {
    userId?: number;
    oldPassword?: string;
    newPassword?: string;
    authType?: number;
    verificationCode: string;
    customerId?: number;
    constructor(){
        this.userId = 0;
        this.oldPassword = "";
        this.newPassword = "";
        this.authType = 0;
        this.customerId = 0;
    }
}
